import { memo, useState, useCallback } from "react";
import { BarcodeScanner, hasMobileCamera } from "./BarcodeScanner";
import { transitions } from "../tokens";

interface ScanButtonProps {
  onScan: (code: string) => void;
  title?: string;
}

export const ScanButton = memo(function ScanButton({ onScan, title }: ScanButtonProps) {
  const [showScanner, setShowScanner] = useState(false);

  const handleScan = useCallback((code: string) => {
    setShowScanner(false);
    onScan(code);
  }, [onScan]);

  if (!hasMobileCamera()) return null;

  return (
    <>
      <button
        type="button"
        onClick={() => setShowScanner(true)}
        aria-label="Scan barcode"
        style={{
          width: "38px",
          height: "38px",
          borderRadius: "8px",
          border: "1.5px solid #e5e5e5",
          background: "#fff",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          transition: `border-color ${transitions.fast}`,
        }}
        onMouseEnter={e => ((e.currentTarget as HTMLButtonElement).style.borderColor = "#111")}
        onMouseLeave={e => ((e.currentTarget as HTMLButtonElement).style.borderColor = "#e5e5e5")}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 7V5a2 2 0 0 1 2-2h2" />
          <path d="M17 3h2a2 2 0 0 1 2 2v2" />
          <path d="M21 17v2a2 2 0 0 1-2 2h-2" />
          <path d="M7 21H5a2 2 0 0 1-2-2v-2" />
          <line x1="7" y1="12" x2="17" y2="12" />
        </svg>
      </button>
      {showScanner && (
        <BarcodeScanner
          onScan={handleScan}
          onClose={() => setShowScanner(false)}
          title={title}
        />
      )}
    </>
  );
});
